module.exports = __webpack_public_path__ + "media/images/upload-example-2-4ebfb7757f1d63e5c7fe70cf9c2aa836.png";